import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../../customer/components";
import useCustomTheme from "expert-web-app/src/utils/hooks/useCustomTheme";
import { ThemeProvider } from "@emotion/react";
const PictureCard = ({
  classes,
  t,
  title,
  imageSource,
  backgroundColor,
  date,
  leftAlign,
  size,
  imageStyles,
  hasViewed
}) => {
  const heights = {
    small: 200,
    medium: 320
  };
  const theme = useCustomTheme();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.simpleCardContainer,
    style: {
      height: heights[size]
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imageContainer,
    style: {
      backgroundColor
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: imageSource,
    className: `${classes.image} ${imageStyles}`
  })), /*#__PURE__*/React.createElement("div", {
    className: leftAlign ? classes.leftAlign : "",
    style: {
      backgroundColor: theme.palette.background.navigation
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.dateRow
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.dateText,
    style: {
      color: theme.palette.text.secondary
    }
  }, date), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.dateText
  }, !hasViewed ? t("New") : "")), /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    variant: "boday2",
    className: `${!leftAlign ? classes.centerTitle : ""}`
  }, t(title)))));
};
const styles = {
  simpleCardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxShadow: "0px 0px 7px 0px rgba(0,0,0,0.2)",
    borderRadius: 8
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80%",
    width: "100%",
    borderRadius: "8px 8px 0px 0px"
  },
  image: {
    maxHeight: "100%",
    maxWidth: "100%"
  },
  centerTitle: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    flexDirection: "column"
  },
  leftAlign: {
    alignSelf: "flex-start",
    borderRadius: "0px 0px 8px 8px",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 14,
    paddingRight: 14,
    textAlign: "left",
    width: "calc(100% - 28px)"
  },
  dateText: {
    paddingBottom: 6
  },
  dateRow: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between"
  }
};
export default withStyles(styles)(withi18n(PictureCard));
PictureCard.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
  imageSource: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  date: PropTypes.string,
  leftAlign: PropTypes.bool,
  size: PropTypes.string,
  imageStyles: PropTypes.string,
  hasViewed: PropTypes.bool
};
PictureCard.defaultProps = {
  leftAlign: false,
  size: "small",
  imageStyles: "",
  hasViewed: true,
  title: ""
};